<template>
  <a-radio-group v-if="tagType=='radio'" @change="handleInput" :value="getValueSting" :disabled="disabled">
    <a-radio v-for="(item, key) in dictOptions" :key="key" :value="item.value">{{ item.text }}</a-radio>
  </a-radio-group>

  <a-radio-group v-else-if="tagType=='radioButton'"  buttonStyle="solid" @change="handleInput" :value="getValueSting" :disabled="disabled">
    <a-radio-button v-for="(item, key) in dictOptions" :key="key" :value="item.value">{{ item.text }}</a-radio-button>
  </a-radio-group>

  <a-select v-else-if="tagType=='select'" :getPopupContainer = "(target) => target.parentNode" :placeholder="placeholder" :disabled="disabled" :value="getValueSting" @change="handleInput">
    <a-select-option :value="undefined">请选择</a-select-option>
    <a-select-option v-for="(item, key) in dictOptions" :key="key" :value="item.value">
      <span style="display: inline-block;width: 100%" :title=" item.text || item.label ">
        {{ item.text || item.label }}
      </span>
    </a-select-option>
  </a-select>
</template>

<script>
  import {postParam} from '@api/manage'

  export default {
    name: "XDictSelectTag",
    props: {
      url:String,
      params: String,
      dictCode: String,
      placeholder: String,
      triggerChange: Boolean,
      disabled: Boolean,
      value: [String, Number],
      type: String
    },
    data() {
      return {
        dictOptions: [],
        tagType:""
      }
    },
    watch:{
      url:{
        immediate:true,
        handler() {
        },
      },
      params:{
        immediate:true,
        handler() {
        },
      },
      dictCode:{
        immediate:true,
        handler() {
          this.initDictData();
        },
      }
    },
    created() {
      // console.log(this.dictCode);
      if(!this.type || this.type==="list"){
        this.tagType = "select"
      }else{
        this.tagType = this.type
      }
      //获取字典数据
      // this.initDictData();
    },
    computed: {
      getValueSting(){
        return this.value != null ? this.value.toString() : undefined;
      },
    },
    methods: {
      initDictData() {
        //根据角色编码查询对应用户
        var params = {params:this.params};
        postParam(this.url, params).then((res) => {
          if (res.success) {
            var dataArr = [];
            var dictCode = this.dictCode;
            if(dictCode !='' && dictCode !=null){
              var dictCodeStr = dictCode.split(',');
              if(dictCodeStr.length==2){
                  if(dictCodeStr[0] !=''&&dictCodeStr[0]!=null&&dictCodeStr[1] !=''&&dictCodeStr[1]!=null){
                    for(var i=0;i<res.result.length;i++){
                      dataArr.push({value:res.result[i][dictCodeStr[0]],text:res.result[i][dictCodeStr[1]],title:res.result[i][dictCodeStr[1]]});
                    }
                  }
              }
            }
            this.dictOptions = dataArr;
          }
        })
      },
      handleInput(e) {
        let val;
        if(this.tagType=="radio"){
          val = e.target.value
        }else{
          val = e
        }
        console.log(val);
        if(this.triggerChange){
          this.$emit('change', val);
        }else{
          this.$emit('input', val);
        }
        this.$emit('input', val);
      },
      setCurrentDictOptions(dictOptions){
        this.dictOptions = dictOptions
      },
      getCurrentDictOptions(){
        return this.dictOptions
      }
    }
  }
</script>

<style scoped>
</style>